import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const PropertyServiceConfig = {
  name: "Property",
  annotations: []
} as ServiceConfig;